/*
 * Author: Danny Ehlers
 * Date: Global error handling intercept. This will broadcast error to the app.component and
 * display a Retry Modal box.
 */

import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, catchError, tap } from 'rxjs';
import { CapNotificationService } from './cap-notification.service';

@Injectable({
  providedIn: 'root'
})
export class CapHttpInterceptorService implements HttpInterceptor {

  constructor(private capNotificationService: CapNotificationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
      tap(event => {
          if (event instanceof HttpResponse) {
            //console.log(" all looks good");
            // http response status code
            //console.log(event.status);
          }
      }, error => {
        //DE (8/29/2018): Send error status to the notification service. The app.component will receive the request.

        var errorMessage;
        if (error.error && error.error.message) {
          // Custom Message
          errorMessage = error.error.message;
        } else {
          // Default message
          errorMessage = error.message;
        }
        this.capNotificationService.broadcastErrorActivated({ errorStatus: error.status, errorMessage: errorMessage});
          // http response status code
          console.log("----response----");
          console.error("status code:");
          console.error(error.status);
          console.error(error.message);
          console.log("--- end of response---");

        })
      )

  }
}
